<ng-container>
    <fa-icon
        class="flex justify-center grow"
        size="2x"
        [class]="{
            'text-custom-orange': data.type === ModalType.WARNING,
            'text-error': data.type === ModalType.ERROR || data.type === ModalType.DANGER,
            'text-secondary': data.type === ModalType.SUCCESS || data.type === ModalType.INFO,
        }"
        [icon]="['fad', iconName]" />
    <h1 mat-dialog-title>
        {{ data.title }}
    </h1>
    @if (data.description) {
        <p
            class="whitespace-pre-line"
            mat-dialog-content>
            {{ data.description }}
        </p>
    }
    <div mat-dialog-actions>
        @if (data.cancelLabel) {
            <app-button
                [label]="data.cancelLabel"
                [type]="
                    data.type === ModalType.ERROR || data.type === ModalType.DANGER
                        ? ButtonType.ALERT_SECONDARY
                        : ButtonType.SECONDARY
                "
                (onClick)="onClick(ModalResultEnum.CANCEL)" />
        }

        <app-button
            [label]="data.confirmLabel"
            [type]="
                data.type === ModalType.ERROR || data.type === ModalType.DANGER ? ButtonType.ALERT : ButtonType.PRIMARY
            "
            (onClick)="onClick(ModalResultEnum.CONFIRM)" />
    </div>
</ng-container>
